export default __webpack_public_path__ + "static/media/blog-img-34.9e450a9b.jpg";